import gql from 'graphql-tag';

export const activeUser = gql`
  mutation activeUser($id: Int,$username: String ){
    activeUser( id: $id, username: $username){
      id
    }
  }
`;
